import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { ConversationHistoryDrawer } from "../ConversationHistoryDrawer/index.js";
import { useState } from "react";
import { PanelLeft, ShoppingBag, SquarePen } from "lucide-react";
import { useStudioAgentName, HeaderWidget } from "@brandclub/bc-widgets";
import { useBrandAppConfig } from "../../../api/cache/appConfigQueryOptions.js";
const getFontWeight = (weight) => {
  const weights = { normal: 400, medium: 500, semibold: 600, bold: 700 };
  return weights[weight] || 600;
};
const ConciergeHeader = ({
  onMenuToggle,
  onComposeClick,
  onConversationSelect,
  showComposeIcon = true,
  cartCount = 0,
  onBagClick,
  onShareClick,
  viewMode
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const studioAgentName = useStudioAgentName();
  const { data: brandAppConfig } = useBrandAppConfig();
  const headerTitle = studioAgentName || (brandAppConfig == null ? void 0 : brandAppConfig.conciergeAgentName) || "Concierge";
  const handleMenuToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    onMenuToggle == null ? void 0 : onMenuToggle();
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const handleConversationSelect = (conversationId, mode) => {
    onConversationSelect == null ? void 0 : onConversationSelect(conversationId, mode);
  };
  const handleBagClick = () => {
    onBagClick == null ? void 0 : onBagClick();
  };
  return /* @__PURE__ */ jsx(HeaderWidget, { widgetId: "concierge-header", displayName: "Concierge Header", children: (state, resolveColor) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "header",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingTop: state.paddingY,
          paddingBottom: state.paddingY,
          paddingLeft: state.paddingX,
          paddingRight: state.paddingX,
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
          maxWidth: state.maxWidth,
          height: state.height,
          backgroundColor: resolveColor(state.backgroundColor)
        },
        children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
            viewMode !== "read-only" && /* @__PURE__ */ jsx(
              "button",
              {
                onClick: handleMenuToggle,
                "aria-label": "Toggle conversation history",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: /* @__PURE__ */ jsx(PanelLeft, { size: state.iconSize, strokeWidth: 2 })
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                onClick: onComposeClick,
                style: {
                  fontSize: state.titleFontSize,
                  fontWeight: getFontWeight(state.titleFontWeight),
                  color: resolveColor(state.titleColor),
                  textDecoration: "none",
                  cursor: "pointer",
                  height: state.buttonSize,
                  display: "flex",
                  alignItems: "center",
                  border: "none",
                  background: "transparent"
                },
                children: headerTitle
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
            onShareClick && /* @__PURE__ */ jsxs(
              "button",
              {
                onClick: onShareClick,
                "aria-label": "Share conversation",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  alignItems: "center",
                  gap: 6,
                  paddingLeft: 10,
                  paddingRight: 10,
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  fontSize: 14,
                  fontWeight: 500,
                  transition: "background-color 200ms ease",
                  whiteSpace: "nowrap"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: [
                  /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: state.iconSize - 2, height: state.iconSize - 2, viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: "M5.36 4.54568L7.2 2.70338V10.393C7.2 10.8736 7.52 11.194 8 11.194C8.48 11.194 8.8 10.8736 8.8 10.393V2.70338L10.64 4.54568C10.96 4.86608 11.44 4.86608 11.76 4.54568C12.08 4.22528 12.08 3.74468 11.76 3.42428L8.56 0.220275C8.48 0.140175 8.4 0.0600751 8.32 0.0600751C8.16 -0.020025 7.92 -0.020025 7.68 0.0600751C7.6 0.0600751 7.52 0.140175 7.44 0.220275L4.24 3.42428C3.92 3.74468 3.92 4.22528 4.24 4.54568C4.56 4.86608 5.04 4.86608 5.36 4.54568ZM15.2 9.59199C14.72 9.59199 14.4 9.91239 14.4 10.393V13.597C14.4 14.0776 14.08 14.398 13.6 14.398H2.4C1.92 14.398 1.6 14.0776 1.6 13.597V10.393C1.6 9.91239 1.28 9.59199 0.8 9.59199C0.32 9.59199 0 9.91239 0 10.393V13.597C0 14.9587 1.04 16 2.4 16H13.6C14.96 16 16 14.9587 16 13.597V10.393C16 9.91239 15.68 9.59199 15.2 9.59199Z",
                      fill: "currentColor"
                    }
                  ) }),
                  /* @__PURE__ */ jsx("span", { children: "Share" })
                ]
              }
            ),
            cartCount > 0 && showComposeIcon && onBagClick && /* @__PURE__ */ jsxs(
              "button",
              {
                onClick: handleBagClick,
                "aria-label": "View shopping bag",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  position: "relative",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: [
                  /* @__PURE__ */ jsx(ShoppingBag, { size: state.iconSize, strokeWidth: 2 }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        position: "absolute",
                        top: -4,
                        right: -4,
                        backgroundColor: resolveColor(state.badgeBgColor),
                        color: resolveColor(state.badgeTextColor),
                        fontSize: state.badgeFontSize,
                        fontWeight: 500,
                        borderRadius: 9999,
                        minWidth: state.badgeMinWidth,
                        height: state.badgeMinWidth,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingLeft: 4,
                        paddingRight: 4
                      },
                      children: cartCount > 99 ? "99+" : cartCount
                    }
                  )
                ]
              }
            ),
            showComposeIcon && /* @__PURE__ */ jsx(
              "button",
              {
                onClick: onComposeClick,
                "aria-label": "Compose new message",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: /* @__PURE__ */ jsx(SquarePen, { size: state.iconSize, strokeWidth: 2 })
              }
            )
          ] })
        ]
      }
    ),
    viewMode !== "read-only" && /* @__PURE__ */ jsx(
      ConversationHistoryDrawer,
      {
        open: isDrawerOpen,
        onClose: handleDrawerClose,
        onConversationSelect: handleConversationSelect
      }
    )
  ] }) });
};
export {
  ConciergeHeader
};
//# sourceMappingURL=index.js.map
